import { LastLoginInfoState } from './partials/LastLoginInfo'

export const AuthenticationState = _ => ({
  ...LastLoginInfoState,

  multifactorAuthenticationSettings: {},
})
